<template>
    <div :bordered="false">
        <div class="table-page-search-wrapper">
            <!-- ========== 统计概览卡片 ========== -->
            <a-row :gutter="16" class="statistics-row">
                <a-col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
                    <div class="stat-card stat-card-cyan">
                        <div class="stat-info">
                            <div class="stat-title">{{ $t(I18N_KEY.COLLECTION + 'monitoringTotalMember') }}</div>
                            <div class="stat-value">
                                {{ statistics.monitoringNumbers }}
                                <span class="stat-unit">{{ $t(I18N_KEY.COLLECTION + 'people') }}</span>
                            </div>
                            <div class="stat-sub">{{ $t(I18N_KEY.COLLECTION + 'onlineRate') }} {{ statistics.onlineRate }}</div>
                        </div>
                        <div class="stat-icon">
                            <a-icon type="team" />
                        </div>
                    </div>
                </a-col>
                <a-col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
                    <div class="stat-card stat-card-green">
                        <div class="stat-info">
                            <div class="stat-title">{{ $t(I18N_KEY.COLLECTION + 'todayCallDuration') }}</div>
                            <div class="stat-value">
                                {{ statistics.callDuration }}
                                <span class="stat-unit">Mins</span>
                            </div>
                            <div class="stat-sub"></div>
                        </div>
                        <div class="stat-icon">
                            <a-icon type="phone" />
                        </div>
                    </div>
                </a-col>
                <a-col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
                    <div class="stat-card stat-card-yellow">
                        <div class="stat-info">
                            <div class="stat-title">{{ $t(I18N_KEY.COLLECTION + 'positionOffsetWarning') }}</div>
                            <div class="stat-value">
                                {{ statistics.offsetNumbers }}
                                <span class="stat-unit">{{ $t(I18N_KEY.COLLECTION + 'anomaly') }}</span>
                            </div>
                            <div class="stat-sub"></div>
                        </div>
                        <div class="stat-icon">
                            <a-icon type="warning" />
                        </div>
                    </div>
                </a-col>
                <a-col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
                    <div class="stat-card stat-card-red">
                        <div class="stat-info">
                            <div class="stat-title">{{ $t(I18N_KEY.COLLECTION + 'currentLockUpPeriodTerminal') }}</div>
                            <div class="stat-value">
                                {{ statistics.lockedNumbers }}
                                <span class="stat-unit">{{ $t(I18N_KEY.COLLECTION + 'device') }}</span>
                            </div>
                            <div class="stat-sub"></div>
                        </div>
                        <div class="stat-icon">
                            <a-icon type="lock" />
                        </div>
                    </div>
                </a-col>
            </a-row>
            <!-- ========== 排名概览卡片（带皇冠图标） ========== -->
            <a-row :gutter="16" class="rank-row">
                <!-- 催收排名 -->
                <a-col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
                    <div class="rank-card">
                        <div class="rank-header rank-header-cyan">
                            <span class="rank-title">{{ $t(I18N_KEY.COLLECTION + 'collectionRank') }}</span>
                            <a class="rank-detail-link" @click="openRankDetail('colRateRank')">{{ $t(I18N_KEY.COLLECTION + 'detail') }}</a>
                        </div>
                        <div class="rank-list">
                            <div v-if="!rankData.colRateRank || rankData.colRateRank.length === 0" class="rank-empty">
                                {{ $t(I18N_KEY.COLLECTION + 'noData') }}
                            </div>
                            <div v-for="(item, index) in rankData.colRateRank" :key="'rate-' + index" class="rank-item">
                                <div class="rank-badge">
                                    <span class="rank-index" :class="{'rank-top3': index < 3}">{{ index + 1 }}</span>
                                    <a-icon v-if="index === 0" type="crown" class="rank-crown rank-crown-gold" />
                                    <a-icon v-else-if="index === 1" type="crown" class="rank-crown rank-crown-silver" />
                                    <a-icon v-else-if="index === 2" type="crown" class="rank-crown rank-crown-bronze" />
                                </div>
                                <span class="rank-name">{{ item.groupName }} - {{ item.mobile }}</span>
                                <span class="rank-value">{{ item.succRate }}%</span>
                            </div>
                        </div>
                    </div>
                </a-col>
                <!-- 通话排名 -->
                <a-col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
                    <div class="rank-card">
                        <div class="rank-header rank-header-green">
                            <span class="rank-title">{{ $t(I18N_KEY.COLLECTION + 'callRank') }}</span>
                            <a class="rank-detail-link" @click="openRankDetail('colCallRank')">{{ $t(I18N_KEY.COLLECTION + 'detail') }}</a>
                        </div>
                        <div class="rank-list">
                            <div v-if="!rankData.colCallRank || rankData.colCallRank.length === 0" class="rank-empty">
                                {{ $t(I18N_KEY.COLLECTION + 'noData') }}
                            </div>
                            <div v-for="(item, index) in rankData.colCallRank" :key="'call-' + index" class="rank-item">
                                <div class="rank-badge">
                                    <span class="rank-index" :class="{'rank-top3': index < 3}">{{ index + 1 }}</span>
                                    <a-icon v-if="index === 0" type="crown" class="rank-crown rank-crown-gold" />
                                    <a-icon v-else-if="index === 1" type="crown" class="rank-crown rank-crown-silver" />
                                    <a-icon v-else-if="index === 2" type="crown" class="rank-crown rank-crown-bronze" />
                                </div>
                                <span class="rank-name">{{ item.groupName }} - {{ item.mobile }}</span>
                                <span class="rank-value">{{ item.callDurationMin }}Mins</span>
                            </div>
                        </div>
                    </div>
                </a-col>
                <!-- 活跃排名 -->
                <a-col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
                    <div class="rank-card">
                        <div class="rank-header rank-header-yellow">
                            <span class="rank-title">{{ $t(I18N_KEY.COLLECTION + 'activityRank') }}</span>
                            <a class="rank-detail-link" @click="openRankDetail('colActivityRank')">{{ $t(I18N_KEY.COLLECTION + 'detail') }}</a>
                        </div>
                        <div class="rank-list">
                            <div v-if="!rankData.colActivityRank || rankData.colActivityRank.length === 0" class="rank-empty">
                                {{ $t(I18N_KEY.COLLECTION + 'noData') }}
                            </div>
                            <div v-for="(item, index) in rankData.colActivityRank" :key="'act-' + index" class="rank-item">
                                <div class="rank-badge">
                                    <span class="rank-index" :class="{'rank-top3': index < 3}">{{ index + 1 }}</span>
                                    <a-icon v-if="index === 0" type="crown" class="rank-crown rank-crown-gold" />
                                    <a-icon v-else-if="index === 1" type="crown" class="rank-crown rank-crown-silver" />
                                    <a-icon v-else-if="index === 2" type="crown" class="rank-crown rank-crown-bronze" />
                                </div>
                                <span class="rank-name">{{ item.groupName }} - {{ item.mobile }}</span>
                                <span class="rank-value">{{ item.callTimes }}{{ $t(I18N_KEY.COLLECTION + 'time') }}</span>
                            </div>
                        </div>
                    </div>
                </a-col>
                <!-- 小组催收排名 -->
                <a-col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
                    <div class="rank-card">
                        <div class="rank-header rank-header-red">
                            <span class="rank-title">{{ $t(I18N_KEY.COLLECTION + 'colRateByGroupRank') }}</span>
                            <a class="rank-detail-link" @click="openRankDetail('colRateByGroupRank')">{{ $t(I18N_KEY.COLLECTION + 'detail') }}</a>
                        </div>
                        <div class="rank-list">
                            <div v-if="!rankData.colRateByGroupRank || rankData.colRateByGroupRank.length === 0" class="rank-empty">
                                {{ $t(I18N_KEY.COLLECTION + 'noData') }}
                            </div>
                            <div v-for="(item, index) in rankData.colRateByGroupRank" :key="'group-rate-' + index" class="rank-item">
                                <div class="rank-badge">
                                    <span class="rank-index" :class="{'rank-top3': index < 3}">{{ index + 1 }}</span>
                                    <a-icon v-if="index === 0" type="crown" class="rank-crown rank-crown-gold" />
                                    <a-icon v-else-if="index === 1" type="crown" class="rank-crown rank-crown-silver" />
                                    <a-icon v-else-if="index === 2" type="crown" class="rank-crown rank-crown-bronze" />
                                </div>
                                <span class="rank-name">{{ item.groupName }}</span>
                                <span class="rank-value">{{ item.groupSuccedColRate }}%</span>
                            </div>
                        </div>
                    </div>
                </a-col>
            </a-row>
            <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                   <a-col :md='10' :sm='10'>
                        <a-form-item :label="$t(I18N_KEY.COLLECTION + 'queryTime')">
                            <a-date-picker v-model='queryParam.queryDate' format='YYYY-MM-DD' value-format="YYYY-MM-DD" style='width: 100%;' />
                        </a-form-item>
                    </a-col>
                    <!-- 催收阶段 -->
                   <a-col :md='6' :sm='8'>
                        <a-form-item :label="$t(I18N_KEY.COLLECTION + 'normalConfig')">
                            <a-select v-model='queryParam.normalConfigId' allowClear
                                >
                                <!-- 情况1：未选分组 → 展示全部阶段 -->
                                <template v-if="!queryParam.groupId">
                                    <a-select-option v-for='item in normalConfigList' :key='item.id' :value='item.id'>
                                        {{ item.name }}
                                    </a-select-option>
                                </template>

                                <!-- 情况2：已选分组 → 只展示联动出来的那一条 -->
                                <template v-else>
                                    <a-select-option
                                        v-if="linkedNormalConfig && linkedNormalConfig.id !== undefined && linkedNormalConfig.id !== null"
                                        :key="linkedNormalConfig.id" :value="linkedNormalConfig.id">
                                        {{ linkedNormalConfig.name }}
                                    </a-select-option>
                                </template>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md='6' :sm='8'>
                        <a-form-item :label="$t(I18N_KEY.COLLECTION + 'grouping')">
                            <a-select v-model='queryParam.groupId' allowClear @change="onChangeGroup">
                                <a-select-option v-for='item in groupList' :key='item.id' :value="item.id">
                                    {{ item.groupName }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <!-- 催收员 -->
                    <a-col :md="6" :sm="8">
                        <a-form-item :label="$t(I18N_KEY.COLLECTION + 'debtCollector')">
                            <a-select v-model='queryParam.keyword' showSearch optionFilterProp="children" allowClear
                                :notFoundContent="$t(I18N_KEY.COLLECTION + 'noData')">
                                <a-select-option v-for="item in userIdList" :key="item.id" :value="item.id">
                                    {{ item.mobile }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="3" :sm="4">
                        <a-button type="primary" @click="searchQuery">{{ $t('search') }}</a-button>
                    </a-col>
                    <a-col :md="4" :sm="4">
                        <a-button @click="searchReset" icon="reload">{{ $t('reset') }}</a-button>
                    </a-col>
                    <a-col :md="4" :sm="4" v-if="canManageConfig">
                        <a-button type="primary" icon="setting" @click="openConfigModal">
                            {{ $t(I18N_KEY.COLLECTION + 'configButton') }}
                        </a-button>
                    </a-col>
                </a-row>
            </a-form>
            <!-- 数据表格 -->
            <a-table ref="table" size="middle" :columns="columns" :dataSource="dataSource" :pagination="false"
                :loading="loading" bordered @change="handleTableChange" :scroll="{ x: 'max-content' }" rowKey="id" class="dark-table">
                <!-- 锁定开关列 -->
                <template slot="lockFlag" slot-scope="text, record">
                    <a-switch 
                        size="small"
                        :checked="String(text) === '2' || text === 2"
                        :loading="record.lockLoading"
                        @change="(checked) => handleLockChange(checked, record)" 
                    />
                </template>
                <!-- 活跃度热力图列 -->
                <template slot="activityHeatmap" slot-scope="text, record">
                        <div class="heatmap-row">
                            <!-- 上班前 -->
                            <div class="heatmap-segment heatmap-segment-before">
                                <div
                                    v-for="slot in rangeOf(record).beforeEnd"
                                    :key="'b' + slot"
                                    class="heatmap-cell"
                                    :style="{ backgroundColor: getHeatmapColor(slot, record) }"
                                    :title="getHeatmapTitle(slot, record)"
                                ></div>
                            </div>

                            <!-- 工作时间 -->
                            <div class="heatmap-segment heatmap-segment-work">
                                <div
                                    v-for="slot in workSlots(record)"
                                    :key="'w' + slot"
                                    class="heatmap-cell"
                                    :style="{ backgroundColor: getHeatmapColor(slot, record) }"
                                    :title="getHeatmapTitle(slot, record)"
                                ></div>
                            </div>

                            <!-- 下班后 -->
                            <div class="heatmap-segment heatmap-segment-after">
                                <div
                                    v-for="slot in afterSlots(record)"
                                    :key="'a' + slot"
                                    class="heatmap-cell"
                                    :style="{ backgroundColor: getHeatmapColor(slot, record) }"
                                    :title="getHeatmapTitle(slot, record)"
                                ></div>
                            </div>
                        </div>
                    </template>
                <!-- 通话数量超链接列 -->
               <template slot="callNumSlot" slot-scope="text, record">
                    <a-tooltip placement="top">
                        <template slot="title">
                            <div>
                                <div>{{ $t(I18N_KEY.COLLECTION + 'connectedNumLabel') }}--{{ record.connectedNum }}</div>
                                <div>{{ $t(I18N_KEY.COLLECTION + 'noAnswerNumLabel') }}--{{ record.noAnswerNum }}</div>
                                <div>{{ $t(I18N_KEY.COLLECTION + 'unKnowNumLabel') }}--{{ record.unKnowNum }}</div>
                            </div>
                        </template>
                        <a>{{ text }}</a>
                    </a-tooltip>
                </template>
                <!-- ===== 新增：操作列 ===== -->
                <template slot="action" slot-scope="text, record">
                    <a class="detail-link-btn" @click="openUserDetail(record)">{{ $t(I18N_KEY.COLLECTION + 'colDetail') }}</a>
                </template>
            </a-table>
            <!-- <div style='margin-top: 15px; text-align: right;' >
                <v-pagination v-if='total' :page-num='form.pageNum' :page-size='form.pageSize' :total='total'
                    @change='handleTableChange' />
            </div> -->
        </div>
        <!-- ========== 配置列表弹窗 ========== -->
        <a-modal
            v-model="configVisible"
            :title="$t(I18N_KEY.COLLECTION + 'configManage')"
            :footer="null"
            :width="900"
            :destroyOnClose="false"
            @cancel="closeConfigModal"
        >
            <div class="config-modal-wrapper">
                <!-- 搜索栏 -->
                <a-form layout="inline" style="margin-bottom: 16px;">
                    <a-form-item :label="$t(I18N_KEY.COLLECTION + 'configKey')">
                        <a-input
                            v-model="configQueryParam.configKeyWord"
                            :placeholder="$t(I18N_KEY.COLLECTION + 'configKeyInput')"
                            allowClear
                            style="width: 220px;"
                        />
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" icon="search" @click="handleConfigSearch">{{ $t('search') }}</a-button>
                        <a-button style="margin-left: 8px;" icon="reload" @click="handleConfigReset">{{ $t('reset') }}</a-button>
                    </a-form-item>
                    <a-form-item style="float: right;" v-if="canManageConfig">
                        <a-button type="primary" icon="plus" @click="openConfigForm('add')">{{ $t('add') }}</a-button>
                    </a-form-item>
                </a-form>
                <!-- 配置表格 -->
                <a-table
                    size="middle"
                    :columns="configColumns"
                    :dataSource="configDataSource"
                    :pagination="false"
                    :loading="configLoading"
                    bordered
                    rowKey="id"
                >
                    <template v-slot:action="record">
                        <a v-if="canManageConfig" @click="openConfigForm('edit', record)">{{ $t('edit') }}</a>
                    </template>
                </a-table>
                <!-- 分页 -->
                <div style="margin-top: 15px; text-align: right;">
                    <v-pagination
                        v-if="configTotal"
                        :page-num="configForm.pageNum"
                        :page-size="configForm.pageSize"
                        :total="configTotal"
                        @change="handleConfigTableChange"
                    />
                </div>
            </div>
        </a-modal>
        <!-- ========== 新增/编辑配置弹窗 ========== -->
        <a-modal
            v-model="configFormVisible"
            :title="configFormType === 'add' ? $t(I18N_KEY.COLLECTION + 'addConfig') : $t(I18N_KEY.COLLECTION + 'editConfig')"
            :width="520"
            :confirmLoading="configSaveLoading"
            :maskClosable="false"
            @ok="handleConfigSave"
            @cancel="closeConfigForm"
        >
            <a-form :form="configFormObj" layout="vertical">
                <a-form-item :label="$t(I18N_KEY.COLLECTION + 'configKey')" required>
                    <a-input
                        v-model="configFormData.configKey"
                        :placeholder="$t(I18N_KEY.COLLECTION + 'configKeyInput')"
                        :disabled="configFormType === 'edit'"
                        :maxLength="100"
                    />
                </a-form-item>
                <a-form-item :label="$t(I18N_KEY.COLLECTION + 'configvalue')" required>
                    <a-input
                        v-model="configFormData.configValue"
                        :placeholder="$t(I18N_KEY.COLLECTION + 'configValueInput')"
                        :maxLength="500"
                    />
                </a-form-item>
                <a-form-item :label="$t(I18N_KEY.COLLECTION + 'configRemark')">
                    <a-textarea
                        v-model="configFormData.configRemark"
                        :placeholder="$t(I18N_KEY.COLLECTION + 'configRemarkInput')"
                        :rows="3"
                        :maxLength="500"
                    />
                </a-form-item>
            </a-form>
        </a-modal>
        <!-- ========== 新增：排名详情弹窗 ========== -->
        <a-modal
            v-model="rankDetailVisible"
            :title="rankDetailTitle"
            :footer="null"
            :width="800"
            @cancel="closeRankDetail"
        >
            <a-table
                size="middle"
                :columns="rankDetailColumns"
                :dataSource="rankDetailData"
                :pagination="rankDetailPagination"
                bordered
                :rowKey="(record, index) => index"
                class="dark-table"
                @change="handleRankDetailTableChange"
            />
        </a-modal>
        <!-- ========== 新增：用户催收详情弹窗 ========== -->
        <a-modal
            v-model="userDetailVisible"
            :title="$t(I18N_KEY.COLLECTION + 'userDetailTitle')"
            :footer="null"
            :width="'90vw'"
            :bodyStyle="{ maxHeight: '80vh', overflow: 'auto', padding: '16px 24px' }"
            wrapClassName="user-detail-modal"
            :destroyOnClose="false"
            @cancel="closeUserDetail"
        >
            <div class="user-detail-wrapper">
                <!-- 时间范围选择 -->
                <a-form layout="inline" style="margin-bottom: 16px;">
                    <a-form-item :label="$t(I18N_KEY.COLLECTION + 'colQueryStartDate')" :required="true">
                        <a-date-picker
                            v-model="userDetailQuery.queryStartDate"
                            format="YYYY-MM-DD"
                            value-format="YYYY-MM-DD"
                            style="width: 180px;"
                            :disabled="userDetailLoading"
                            :placeholder="$t(I18N_KEY.COLLECTION + 'pleaseSelectColQueryStartDate')"
                        />
                    </a-form-item>
                    <a-form-item :label="$t(I18N_KEY.COLLECTION + 'colQueryEndDate')" :required="true">
                        <a-date-picker
                            v-model="userDetailQuery.queryEndDate"
                            format="YYYY-MM-DD"
                            value-format="YYYY-MM-DD"
                            style="width: 180px;"
                            :disabled="userDetailLoading"
                            :placeholder="$t(I18N_KEY.COLLECTION + 'pleaseSelectColQueryEndDate')"
                        />
                    </a-form-item>
                    <a-form-item>
                        <a-button
                            type="primary"
                            icon="search"
                            :loading="userDetailLoading"
                            @click="handleUserDetailSearch"
                        >
                            {{ $t('search') }}
                        </a-button>
                    </a-form-item>
                </a-form>

                <!-- 详情表格（字段与主表一致 + 多一列 queryDate） -->
                <a-table
                    size="middle"
                    :columns="userDetailColumns"
                    :dataSource="userDetailDataSource"
                    :pagination="false"
                    :loading="userDetailLoading"
                    bordered
                    rowKey="id"
                    :scroll="{ x: 'max-content' }"
                    class="dark-table"
                >
                    <!-- 用户详情：通话数量超链接列 -->
                    <template slot="userCallNumSlot" slot-scope="text, record">
                        <a-tooltip placement="top">
                            <template slot="title">
                                <div>
                                    <div>{{ $t(I18N_KEY.COLLECTION + 'connectedNumLabel') }}--{{ record.connectedNum }}</div>
                                    <div>{{ $t(I18N_KEY.COLLECTION + 'noAnswerNumLabel') }}--{{ record.noAnswerNum }}</div>
                                    <div>{{ $t(I18N_KEY.COLLECTION + 'unKnowNumLabel') }}--{{ record.unKnowNum }}</div>
                                </div>
                            </template>
                            <a>{{ text }}</a>
                        </a-tooltip>
                    </template>
                    <!-- 用户详情：活跃度热力图列（逻辑复用主表） -->
                    <template slot="activityHeatmap" slot-scope="text, record">
                        <div class="heatmap-row">
                            <!-- 上班前 -->
                            <div class="heatmap-segment heatmap-segment-before">
                                <div
                                    v-for="slot in rangeOf(record).beforeEnd"
                                    :key="'b' + slot"
                                    class="heatmap-cell"
                                    :style="{ backgroundColor: getHeatmapColor(slot, record) }"
                                    :title="getHeatmapTitle(slot, record)"
                                ></div>
                            </div>

                            <!-- 工作时间 -->
                            <div class="heatmap-segment heatmap-segment-work">
                                <div
                                    v-for="slot in workSlots(record)"
                                    :key="'w' + slot"
                                    class="heatmap-cell"
                                    :style="{ backgroundColor: getHeatmapColor(slot, record) }"
                                    :title="getHeatmapTitle(slot, record)"
                                ></div>
                            </div>

                            <!-- 下班后 -->
                            <div class="heatmap-segment heatmap-segment-after">
                                <div
                                    v-for="slot in afterSlots(record)"
                                    :key="'a' + slot"
                                    class="heatmap-cell"
                                    :style="{ backgroundColor: getHeatmapColor(slot, record) }"
                                    :title="getHeatmapTitle(slot, record)"
                                ></div>
                            </div>
                        </div>
                    </template>
                </a-table>

                <!-- 分页 -->
                <div style="margin-top: 15px; text-align: right;">
                    <v-pagination
                        v-if="userDetailTotal"
                        :page-num="userDetailForm.pageNum"
                        :page-size="userDetailForm.pageSize"
                        :total="userDetailTotal"
                        @change="handleUserDetailTableChange"
                    />
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { filterObj } from '@/utils/util'
import { getHeaders } from '@/utils/request'
import { hasRoleCode } from '@/utils/permissions'
import { getSysGroup } from '@/webpublicapi/platformCollection'
import { getAllNormalConfig } from '@/webpublicapi/normalConfig'
import { getColUserList } from '@/api/system'
import { queryCollectionSurveillanceInfo, queryUserCollectionDetail, querySurveillanceConfig, saveSurveillanceConfig, lockAccount, queryColStatistics, queryColRelatedRank, getCollectorMobile } from '@/webpublicapi/collection'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import vModal from '../modules/Modal'
import moment from 'moment'
const I18N_KEY = {
    COLLECTION: 'collection.',
}
export default {
    name: 'PayrollBatchList',
    components: {
        Dict,
        DictSelect,
        vModal
    },
    data() {
        return {
            I18N_KEY,
            isButtonDisabled: false,
            visible: false,
            selectedRowKeys: [],
            loading: false,
            total: 0,
            isFinanceRole: false,
            isHrRole: false,
            // 仅 admin / SUPER_ADMIN 可管理监控配置
            canManageConfig: false,
            id: null,
            batchNo: null,
            fileName: null,
            createTime: null,
            totalCount: null,
            totalAmount: null,
            effectiveCount: null,
            effectiveAmount: null,
            rejectCount: null,
            rejectReason: null,
            status: null,
            isClearingSorter: false,
            linkedNormalConfig: null,
            userIdList: [],
            groupList: [],
            normalConfigList: [],
            dataSource: [],
            // 排序参数
            sortField: '',
            sortOrder: '',
            form: {
                pageNum: 1,
                pageSize: 30,
            },
            queryParam: {
                keyword: null,
                date: [],
                queryDate: null,
                type: null,
                status: null,
                groupId: undefined,
                normalConfigId: undefined,
            },
            uploadDataParam: {},
            // ===== 统计概览数据 =====
            statistics: {
                monitoringNumbers: 0,
                onlineRate: '0',
                callDuration: 0,
                offsetNumbers: 0,
                lockedNumbers: 0
            },
            // ===== 排名数据 =====
            rankData: {
                colRateRank: [],
                colCallRank: [],
                colActivityRank: [],
                colRateByGroupRank: []
            },
            // ===== 新增：排名全量数据与详情弹窗 =====
            rankAllData: {
                colRateRank: [],
                colCallRank: [],
                colActivityRank: [],
                colRateByGroupRank: []
            },
            rankDetailVisible: false,
            rankDetailType: '',
            rankDetailData: [],
            rankDetailColumns: [],
            rankDetailPagination: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            // ===== 热力图染色阈值（从接口解析） =====
            heatmapThresholds: {
                low: 1,
                middleLow: 2,
                middle: 3,
                middleHigh: 4,
                high: 5
            },
            // ===== 配置管理相关数据 =====
            configVisible: false,
            configLoading: false,
            configSaveLoading: false,
            configTotal: 0,
            configDataSource: [],
            configQueryParam: {
                configKeyWord: null
            },
            configForm: {
                pageNum: 1,
                pageSize: 10,
            },
            // 新增/编辑弹窗
            configFormVisible: false,
            configFormType: 'add', // 'add' | 'edit'
            configFormData: {
                id: null,
                configKey: '',
                configValue: '',
                configRemark: ''
            },
            configFormObj: null,
            // ===== 新增：用户催收详情弹窗 =====
            userDetailVisible: false,
            userDetailLoading: false,
            userDetailUserId: null,
            userDetailTotal: 0,
            userDetailDataSource: [],
            userDetailQuery: {
                queryStartDate: null,
                queryEndDate: null
            },
            userDetailForm: {
                pageNum: 1,
                pageSize: 10
            },
            userDetailColumns: [],
            //状态对应值
            locationStatusMap: {
                '0': 'locationStatusOffline',
                '1': 'locationStatusNormal',
                '2': 'locationStatusOffset'
            },
            clockInStatusMap: {
                '0': 'clockInStatusNotClocked',
                '1': 'clockInStatusNormal',
                '2': 'clockInStatusLate'
            }
        }
    },
    computed: {
        rankDetailTitle() {
            const titleMap = {
                colRateRank: this.$t(I18N_KEY.COLLECTION + 'collectionDetail'),
                colCallRank: this.$t(I18N_KEY.COLLECTION + 'callRankDetail'),
                colActivityRank: this.$t(I18N_KEY.COLLECTION + 'activityRankDetail'),
                colRateByGroupRank: this.$t(I18N_KEY.COLLECTION + 'colRateByGroupRank')
            };
            return titleMap[this.rankDetailType] || this.$t(I18N_KEY.COLLECTION + 'defaultRankDetail');
        },
        columns() {
            const h = this.$createElement;
            return [
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'index'),
                    align: 'center',
                    width: 70,
                    sorter: false,
                    customRender: (text, record, index) => {
                        const pageNum = this.form.pageNum || 1;
                        const pageSize = this.form.pageSize || 10;
                        return (pageNum - 1) * pageSize + index + 1;
                    }
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'groupName'),
                    align: 'center',
                    dataIndex: 'groupName',
                    sorter: true,
                    sortOrder: this.sortField === 'groupName' ? this.sortOrder : null
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionLevel'),
                    align: 'center',
                    dataIndex: 'collectionLevel',
                    sorter: true,
                    sortOrder: this.sortField === 'collectionLevel' ? this.sortOrder : null
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionLoginNo'),
                    align: 'center',
                    dataIndex: 'collectionLoginNo',
                    sorter: true,
                    sortOrder: this.sortField === 'collectionLoginNo' ? this.sortOrder : null
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'locationStatus'),
                    align: 'center',
                    dataIndex: 'locationStatusName',
                    sorter: true,
                    sortOrder: this.sortField === 'locationStatusName' ? this.sortOrder : null,
                    customRender: (text, record) => {
                        // 优先用码值映射，映射不到再兜底显示原值
                        const code = record.locationStatus;
                        const key = this.locationStatusMap[code];
                        const label =  key ? this.$t(I18N_KEY.COLLECTION + key) : (text || '-');
                        // 颜色映射：0 红 / 1 绿 / 2 黄
                        const colorMap = {
                            '0': '#ff4d4f', // 红
                            '1': '#52c41a', // 绿
                            '2': '#fadb14'  // 黄
                        };
                        const color = colorMap[code];
                        return color
                            ? this.$createElement('span', { style: { color } }, label)
                            : label;
                    }
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'clockInStatus'),
                    align: 'center',
                    dataIndex: 'clockInStatusName',
                    sorter: true,
                    sortOrder: this.sortField === 'clockInStatusName' ? this.sortOrder : null,
                    customRender: (text, record) => {
                        const code = record.clockInStatus;
                        const key = this.clockInStatusMap[code];
                        const label =  key ? this.$t(I18N_KEY.COLLECTION + key) : (text || '-');
                        // 颜色映射：0 红 / 1 绿 / 2 黄
                        const colorMap = {
                            '0': '#ff4d4f',
                            '1': '#52c41a',
                            '2': '#fadb14'
                        };
                        const color = colorMap[code];
                        return color
                            ? this.$createElement('span', { style: { color } }, label)
                            : label;
                    }
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'callNum'),
                    align: 'center',
                    dataIndex: 'callNum',
                    sorter: true,
                    sortOrder: this.sortField === 'callNum' ? this.sortOrder : null,
                    scopedSlots: { customRender: 'callNumSlot' }
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionNum'),
                    align: 'center',
                    dataIndex: 'collectionNum',
                    scopedSlots: { customRender: 'status' },
                    sorter: true,
                    sortOrder: this.sortField === 'collectionNum' ? this.sortOrder : null
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionRecordCount'),
                    align: 'center',
                    dataIndex: 'collectionRecordCount',
                    sorter: true,
                    sortOrder: this.sortField === 'collectionRecordCount' ? this.sortOrder : null
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'succedColNum'),
                    align: 'center',
                    dataIndex: 'succedNum',
                    sorter: true,
                    sortOrder: this.sortField === 'succedNum' ? this.sortOrder : null
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionRate'),
                    align: 'center',
                    dataIndex: 'collectionRate',
                    sorter: true,
                    sortOrder: this.sortField === 'collectionRate' ? this.sortOrder : null,
                    customRender: (text) => {
                        return `${text ?? 0}%`
                    }
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'colBiasRate'),
                    align: 'center',
                    dataIndex: 'personSuccedColBiasRate',
                    sorter: true,
                    sortOrder: this.sortField === 'personSuccedColBiasRate' ? this.sortOrder : null,
                    customRender: (text) => {
                        const num = Number(text);
                        const label = `${text ?? 0}%`;
                        // 数值 < 0 显示红色
                        const isNegative = !isNaN(num) && num < 0;
                        return isNegative
                            ? this.$createElement('span', { style: { color: '#ff4d4f' } }, label)
                            : label;
                    }
                },
                // ===== 修改点：活跃度列 (直接使用h函数渲染Tooltip) =====
                {
                    title: () => {
                        return h('span', [
                            this.$t(I18N_KEY.COLLECTION + 'collectionActivity'),
                            h('a-tooltip', {
                                props: { placement: 'top' },
                                scopedSlots: {
                                    title: () => h('div', this.$t(I18N_KEY.COLLECTION + 'activityMsg'))
                                }
                            }, [
                                h('a-icon', {
                                    props: { type: 'question-circle' },
                                    style: { marginLeft: '6px', color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }
                                })
                            ])
                        ]);
                    },
                    align: 'center',
                    dataIndex: 'collectionActivity',
                    scopedSlots: { customRender: 'activityHeatmap' },
                    width: 620,
                    sorter: false // 热力图不排序
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'lockFlag'),
                    align: 'center',
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'lockFlag' },
                    sorter: true,
                    sortOrder: this.sortField === 'status' ? this.sortOrder : null
                }
                // ===== 新增：操作列 =====
                // {
                //     title: this.$t('action'),
                //     align: 'center',
                //     width: 90,
                //     fixed: 'right',
                //     scopedSlots: { customRender: 'action' },
                //     sorter: false
                // }
            ]
        },
        configColumns() {
            return [
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'configKey'),
                    align: 'center',
                    dataIndex: 'configKey',
                    width: 200,
                    sorter: true
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'configvalue'),
                    align: 'center',
                    dataIndex: 'configValue',
                    width: 250,
                    ellipsis: true,
                    sorter: true
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'configRemark'),
                    align: 'center',
                    dataIndex: 'configRemark',
                    ellipsis: true,
                    sorter: true
                },
                {
                    title: this.$t('action'),
                    align: 'center',
                    width: 100,
                    scopedSlots: { customRender: 'action' },
                    sorter: false
                }
            ]
        }
    },
    created() {
        this.canManageConfig = hasRoleCode('admin') || hasRoleCode('SUPER_ADMIN');
        getSysGroup().then(res => {
            this.groupList = res.data || []
        });
        getAllNormalConfig().then(res => {
            this.normalConfigList.push({
                'name': 'ALL',
                'id': '',
                'value': ''
            });
            res.data.forEach(item => {
                this.normalConfigList.push(item)
            })
        });
        this.loadCollectorList();
        this.loadData();
    },
    methods: {
        getHeaders() {
            return getHeaders()
        },
        handleModalClose() {
            this.visible = false;
            this.form.pageNum = 1
            this.loadData();
        },
        loadCollectorList() {
            return getCollectorMobile().then(res => {
                this.userIdList = [];   // 先清空，避免重复 push
                const keys = Object.keys(res.data || {});
                for (const key of keys) {
                    this.userIdList.push({
                        mobile: key,
                        id: res.data[key]
                    });
                }
            });
        },

        // 把 'HH:mm' / 'HH:mm:ss' 转成分钟
        parseTimeToMinutes(t) {
            if (!t) return null;
            const parts = String(t).split(':');
            if (parts.length < 2) return null;
            const h = parseInt(parts[0], 10);
            const m = parseInt(parts[1], 10);
            if (isNaN(h) || isNaN(m)) return null;
            return h * 60 + m;
        },

        // 分钟 → slot（向上取整到所在的 10 分钟块）
        minuteToSlot(minute) {
            if (minute === null) return null;
            return Math.floor(minute / 10) + 1;
        },

        // 计算三段区间：{ beforeStart, beforeEnd, workStart, workEnd, afterStart, afterEnd }
        getWorkRanges(record) {
            const onMin = this.parseTimeToMinutes(record.onWorkTime);
            const offMin = this.parseTimeToMinutes(record.offWorkTime);

            // 不跨天
            if (onMin <= offMin) {
                const ws = this.minuteToSlot(onMin);       // 上班 slot
                const we = this.minuteToSlot(offMin - 1);  // 下班前一格（下班那格算工作时间外）
                return {
                    hasWork: true,
                    beforeStart: 1,        beforeEnd: ws - 1,
                    workStart: ws,         workEnd: we,
                    afterStart: we + 1,    afterEnd: 144
                };
            }
        },

        // 上班前：slot 1 ~ beforeEnd
        rangeOf(record) {
            const r = this.getWorkRanges(record);
            return { beforeEnd: Math.max(r.beforeEnd, 0) };
        },

        // 工作时间：返回一个数组 [ws, ws+1, ..., we]
        workSlots(record) {
            const r = this.getWorkRanges(record);
            if (!r.hasWork) return [];
            const arr = [];
            for (let i = r.workStart; i <= r.workEnd; i++) arr.push(i);
            return arr;
        },

        // 下班后：返回 [afterStart, ..., 144]
        afterSlots(record) {
            const r = this.getWorkRanges(record);
            if (r.afterStart > r.afterEnd) return [];
            const arr = [];
            for (let i = r.afterStart; i <= r.afterEnd; i++) arr.push(i);
            return arr;
        },

        searchQuery() {
            this.form.pageNum = 1
            this.sortField = ''
            this.sortOrder = ''
            this.loadData()
        },
        onChangeGroup(groupId) {
            // 1. 清空联动状态
            this.linkedNormalConfig = null
            this.queryParam.normalConfigId = undefined
            this.userIdList = []
            this.queryParam.keyword = null

            if (!groupId) {
                // 清空分组 → 阶段框回到"全部阶段"模式，催收员回到"暂无数据"
                return
            }

            // 2. 从 groupList 找到该组，取 collectionLevel
            const targetGroup = this.groupList.find(g => String(g.id) === String(groupId))
            if (!targetGroup) {
                return
            }

            // 3. 用 collectionLevel 匹配 normalConfigList 的 id → 取 name
            const level = targetGroup.collectionLevel
            if (level !== undefined && level !== null && level !== '') {
                const matchedConfig = this.normalConfigList.find(
                    c => String(c.id) === String(level)
                )
                if (matchedConfig) {
                    this.linkedNormalConfig = {
                        id: matchedConfig.id,
                        name: matchedConfig.name
                    }
                    this.queryParam.normalConfigId = matchedConfig.id
                }
            }

            // 4. 加载该组催收员
            getColUserList({
                pageNum: 1,
                pageSize: 1000,
                userstatus: "1",
                groupIdP: groupId
            }).then(res => {
                const rows = (res && res.data && res.data.rows) ? res.data.rows : []
                this.userIdList = rows
            }).catch(e => {
                this.userIdList = []
                this.$message.error(e.message || 'query collector fail')
            })
        },
        loadData() {
            this.loading = true
            const params = this.getQueryParams()
            queryCollectionSurveillanceInfo(params)
                .then((res) => {
                    if (res.code === 1000) {
                        const data = res.data || {}
                        this.total = data.total || 0
                        console.log("页面数量", this.total);
                        
                        const list = Array.isArray(data.list) ? data.list : []
                        this.dataSource = list.map(item => ({
                            ...item,
                            lockLoading: false
                        }))
                        
                        // 提取热力图染色阈值（兼容 data 根级别或单条记录级别）
                        if (res.data) {
                            this.heatmapThresholds = {
                                low: this.parseThreshold(res.data.heatmapLowTotal, 1),
                                middleLow: this.parseThreshold(res.data.heatmapMiddleLowTotal, 2),
                                middle: this.parseThreshold(res.data.heatmapMiddleTotal, 3),
                                middleHigh: this.parseThreshold(res.data.heatmapMiddleHighTotal, 4),
                                high: this.parseThreshold(res.data.heatmapHighTotal, 5)
                            }
                        }
                    } else {
                        this.$message.error(res.msg)
                        this.dataSource = []
                    }
                    this.loading = false
                })
                .catch((e) => {
                    this.loading = false
                    this.$message.error(e.message)
                })
            this.loadStatistics();
            this.loadRankData();
        },
        // 解析阈值，兼容字符串/数字，兜底默认值
        parseThreshold(val, defaultVal) {
            if (val === undefined || val === null || val === '') return defaultVal
            const parsed = parseInt(val)
            return isNaN(parsed) ? defaultVal : parsed
        },
        // 获取指定 slot 的通话总数
        getCallTotal(slot, record) {
            if (!record.heatmapList || !Array.isArray(record.heatmapList)) {
                return 0
            }
            const item = record.heatmapList.find(h => parseInt(h.slotNo) === slot)
            return item ? parseInt(item.callTotal) : 0
        },
        // 获取热力图 tooltip 标题
        getHeatmapTitle(slot, record) {
            const callTotal = this.getCallTotal(slot, record)
            const hour = Math.floor((slot - 1) / 6)
            const minute = ((slot - 1) % 6) * 10
            const timeStr = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
            const personTotal = record.callPersonTotal ?? 0
            const personRate = record.callPersonRate ?? '0%'

            const line1 = `${timeStr}` + this.$t(I18N_KEY.COLLECTION + 'callTimes') + `:` + `${callTotal}`
            const line2 = this.$t(I18N_KEY.COLLECTION + 'nowActSum') + `:` + `${personTotal}`
            const line3 = this.$t(I18N_KEY.COLLECTION + 'nowActRate') + `:` + `${personRate}`

             return `${line1}\n${line2}\n${line3}`
        },
        // 获取热力图单元格颜色
        getHeatmapColor(slot, record) {
            const callTotal = this.getCallTotal(slot, record)
            if (callTotal === 0) {
                return '#2a2f3d' // 无数据时显示深灰色底，与其他卡片协调
            }
            // 优先取单条记录的阈值，取不到再用接口返回的全局阈值
            const low = this.parseThreshold(record.heatmapLowTotal, this.heatmapThresholds.low)
            const middleLow = this.parseThreshold(record.heatmapMiddleLowTotal, this.heatmapThresholds.middleLow)
            const middle = this.parseThreshold(record.heatmapMiddleTotal, this.heatmapThresholds.middle)
            const middleHigh = this.parseThreshold(record.heatmapMiddleHighTotal, this.heatmapThresholds.middleHigh)
            const high = this.parseThreshold(record.heatmapHighTotal, this.heatmapThresholds.high)
            if (callTotal <= low) {
                return '#90EE90' // 浅绿色
            } else if (callTotal <= middleLow) {
                return '#52c41a' // 绿色
            } else if (callTotal <= middle) {
                return '#fadb14' // 黄色
            } else if (callTotal <= middleHigh) {
                return '#fa8c16' // 橙色
            } else if (callTotal <= high) {
                return '#f5222d' // 红色
            } else {
                return '#f5222d' // 超过最高阈值也显示红色
            }
        },
        getQueryParams() {
            const data = {
                ...this.queryParam,
                pageNum: this.form.pageNum,
                pageSize: this.form.pageSize,
                sortField: this.sortField,
                sortOrder: this.sortOrder
            }
            return filterObj(data)
        },
        transformTime(time) {
            if (!moment.isMoment(time)) {
                return '';
            }
            return time.format('YYYY-MM-DD')
        },
        // a-table change：处理分页+排序
        handleTableChange(pagination, filters, sorter) {
            // 1. 兼容处理 v-pagination 和 a-table 的参数格式
            let pageNum = this.form.pageNum;
            let pageSize = this.form.pageSize;

            if (typeof pagination === 'number') {
                pageNum = pagination;
                pageSize = filters || this.form.pageSize;
            } else if (pagination && typeof pagination === 'object') {
                if (pagination.current || pagination.pageNum) {
                    pageNum = pagination.current || pagination.pageNum;
                }
                if (pagination.pageSize) {
                    pageSize = pagination.pageSize;
                }
            }

            // 2. 判断是否是分页操作（页码或每页条数发生变化）
            const isPageChange = pageNum !== this.form.pageNum || pageSize !== this.form.pageSize;

            if (isPageChange) {
                // 🔥 核心修复：分页操作时，直接清空排序状态
                this.sortField = '';
                this.sortOrder = '';
                this.form.pageNum = pageNum;
                this.form.pageSize = pageSize;
                
                // 重新请求数据（恢复默认排序）
                this.loadData();
                return;
            }

            // 3. 处理排序逻辑（此时是点击表头触发的）
            if (sorter && sorter.field && sorter.order) {
                // 记录当前的排序状态，使受控排序生效
                this.sortField = sorter.field;
                this.sortOrder = sorter.order;

                // 有排序条件，进行本地排序
                const { field, order } = sorter;
                let tempList = [...this.dataSource];
                tempList.sort((a, b) => {
                    let valA = a[field];
                    let valB = b[field];
                    if (typeof valA === 'string' && valA.includes('%')) valA = parseFloat(valA);
                    if (typeof valB === 'string' && valB.includes('%')) valB = parseFloat(valB);
                    const numA = Number(valA);
                    const numB = Number(valB);
                    if (!isNaN(numA) && !isNaN(numB)) {
                        return order === 'descend' ? numB - numA : numA - numB;
                    }
                    const strA = String(valA ?? '');
                    const strB = String(valB ?? '');
                    return order === 'descend' ? strB.localeCompare(strA) : strA.localeCompare(strB);
                });
                this.form.pageNum = pageNum;
                this.form.pageSize = pageSize;
                this.dataSource = tempList;
                return;
            }

            // 4. 取消排序（第三次点击表头），重新加载数据
            if (sorter && !sorter.order) {
                this.sortField = '';
                this.sortOrder = '';
                this.form.pageNum = pageNum;
                this.form.pageSize = pageSize;
                this.loadData();
                return;
            }

            // 5. 常规分页切换兜底
            this.form.pageNum = pageNum;
            this.form.pageSize = pageSize;
            this.loadData();
        },
        searchReset() {
            this.queryParam = {
                keyword: null,
                date: [],
                type: null,
                status: null,
                groupId: null,
                normalConfigId: null,
                queryDate: null
            }
            this.linkedNormalConfig = null
            this.userIdList = []

            this.form.pageNum = 1
            this.sortField = ''
            this.sortOrder = ''
            this.loadCollectorList();
            this.loadData();
        },
        handleChangeUpload(info) {
            if (info.file.status === 'done') {
                if (info.file.response?.code === 1000) {
                    this.$message.success(`${info.file.name} 上传成功`)
                    this.loadData()
                } else {
                    this.$message.error(info.file.response?.msg || '上传失败')
                }
            } else if (info.file.status === 'error') {
                this.$message.error(`${info.file.name} 上传失败`)
            }
        },
        changeModal(visible) {
            this.visible = visible;
            if (!visible) {
                this.loadData();
            }
        },
        handleDetail(row) {
            this.id = row.id;
            this.batchNo = row.batchNo;
            this.fileName = row.fileName;
            this.createTime = row.createTime;
            this.totalCount = row.totalCount;
            this.totalAmount = row.totalAmount;
            this.effectiveCount = row.effectiveCount;
            this.effectiveAmount = row.effectiveAmount;
            this.rejectCount = row.rejectCount;
            this.rejectReason = row.rejectReason;
            this.status = row.status;
            this.changeModal(true);
        },
        // ==================== 统计概览方法 ====================
        loadStatistics() {
            const params = this.getQueryParams()
            queryColStatistics(params)
                .then((res) => {
                    if (res.code === 1000 && res.data) {
                        const d = res.data;
                        this.statistics = {
                            monitoringNumbers: d.monitoringNumbers || 0,
                            onlineRate: d.onlineRate !== undefined && d.onlineRate !== null ? d.onlineRate : '0',
                            callDuration: d.callDuration || 0,
                            offsetNumbers: d.offsetNumbers || 0,
                            lockedNumbers: d.lockedNumbers || 0
                        };
                    }
                })
                .catch(() => {
                    // 静默失败
                });
        },
        // ===== 修改点：排名数据加载（只取前3，全量存储） =====
        loadRankData() {
            const params = this.getQueryParams()
            queryColRelatedRank(params)
                .then((res) => {
                    if (res.code === 1000 && res.data) {
                        const d = res.data;
                        
                        // 保存全量数据（供详情弹窗使用）
                        this.rankAllData = {
                            colRateRank: d.colRateRank || [],
                            colCallRank: d.colCallRank || [],
                            colActivityRank: d.colActivityRank || [],
                            colRateByGroupRank: d.colRateByGroupRank || []
                        };
                        // 截取前3条用于卡片展示
                        this.rankData = {
                            colRateRank: (d.colRateRank || []).slice(0, 3),
                            colCallRank: (d.colCallRank || []).slice(0, 3),
                            colActivityRank: (d.colActivityRank || []).slice(0, 3),
                            colRateByGroupRank: (d.colRateByGroupRank || []).slice(0, 3)
                        };
                    }
                })
                .catch(() => {
                    // 静默失败
                });
        },
        // ===== 新增：排名详情弹窗方法 =====
        openRankDetail(type) {
            this.rankDetailType = type;
            // 拿到当前类型全部数据
            const allList = this.rankAllData[type] || [];
            this.rankDetailPagination = {
                current: 1,
                pageSize: 10,
                total: allList.length
            };
            // 第一页切片
            this.rankDetailData = allList.slice(0, this.rankDetailPagination.pageSize);

            // 动态设置列
            if (type === 'colRateRank') {
                this.rankDetailColumns = [
                    { title: this.$t(I18N_KEY.COLLECTION + 'groupName'), dataIndex: 'groupName', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'collectionLoginNo'), dataIndex: 'mobile', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'collectionRate'), dataIndex: 'succRate', align: 'center', customRender: (text) => text + '%' }
                ];
            } else if (type === 'colCallRank') {
                this.rankDetailColumns = [
                    { title: this.$t(I18N_KEY.COLLECTION + 'groupName'), dataIndex: 'groupName', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'collectionLoginNo'), dataIndex: 'mobile', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'todayCallDuration'), dataIndex: 'callDurationMin', align: 'center', customRender: (text) => text + ' Mins' }
                ];
            } else if (type === 'colActivityRank') {
                this.rankDetailColumns = [
                    { title: this.$t(I18N_KEY.COLLECTION + 'groupName'), dataIndex: 'groupName', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'collectionLoginNo'), dataIndex: 'mobile', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'activityTime'), dataIndex: 'callTimes', align: 'center', customRender: (text) => text + ' ' +  this.$t(I18N_KEY.COLLECTION + 'time')}
                ];
            } else if (type === 'colRateByGroupRank') {
                this.rankDetailColumns = [
                    { title: this.$t(I18N_KEY.COLLECTION + 'groupName'), dataIndex: 'groupName', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'collectionNum'), dataIndex: 'collectionNum', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'succedColNum'), dataIndex: 'succedNum', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'collectionRate'), dataIndex: 'groupSuccedColRate', align: 'center', customRender: (text) => text + '%' }
                ];
            }
            this.rankDetailVisible = true;
        },
        closeRankDetail() {
            this.rankDetailVisible = false;
            this.rankDetailType = '';
            this.rankDetailData = [];
            this.rankDetailColumns = [];
        },
        // 修复：排名详情分页切换，前端切片
        handleRankDetailTableChange(pagination) {
            this.rankDetailPagination = pagination;
            const allList = this.rankAllData[this.rankDetailType] || [];
            const start = (pagination.current - 1) * pagination.pageSize;
            const end = start + pagination.pageSize;
            this.rankDetailData = allList.slice(start, end);
        },
        handleLockChange(checked, record) {
            const userId = record.userId || record.id;
            const delFlag = checked ? '1' : '0';
            
            record.lockLoading = true;
            lockAccount({ userId, delFlag })
                .then((res) => {
                    if (res.code === 1000) {
                        this.$message.success(checked ? this.$t(I18N_KEY.COLLECTION + 'lockSuc') : this.$t(I18N_KEY.COLLECTION + 'unLockSuc'));
                        record.delFlag = delFlag;
                        this.loadData();
                    } else {
                        this.$message.error(res.msg || 'action fail');
                    }
                })
                .catch((e) => {
                    this.$message.error(e.message || 'action exception');
                }).finally(() => {
                    // 请求结束，关闭加载动画
                    record.lockLoading = false;
                });
        },
        // ==================== 配置管理方法 ====================
        openConfigModal() {
            this.configVisible = true;
            this.configForm.pageNum = 1;
            this.configQueryParam.configKeyWord = null;
            this.loadConfigData();
        },
        closeConfigModal() {
            this.configVisible = false;
            this.configDataSource = [];
            this.configTotal = 0;
        },
        loadConfigData() {
            this.configLoading = true;
            const params = {
                ...this.configQueryParam,
                pageNum: this.configForm.pageNum,
                pageSize: this.configForm.pageSize
            };
            querySurveillanceConfig(filterObj(params))
                .then((res) => {
                    if (res.code === 1000) {
                        this.configTotal = res.data.total || 0;
                        this.configDataSource = res.data.list || [];
                    } else {
                        this.$message.error(res.msg || 'query config fail');
                        this.configDataSource = [];
                    }
                    this.configLoading = false;
                })
                .catch((e) => {
                    this.configLoading = false;
                    this.$message.error(e.message || 'query config exception');
                });
        },
        handleConfigSearch() {
            this.configForm.pageNum = 1;
            this.loadConfigData();
        },
        handleConfigReset() {
            this.configQueryParam.configKeyWord = null;
            this.configForm.pageNum = 1;
            this.loadConfigData();
        },
        handleConfigTableChange(pageNum, pageSize) {
            this.configForm.pageNum = pageNum;
            this.configForm.pageSize = pageSize;
            this.loadConfigData();
        },
        openConfigForm(type, record = null) {
            this.configFormType = type;
            this.configFormVisible = true;
            if (type === 'edit' && record) {
                this.configFormData = {
                    id: record.id || null,
                    configKey: record.configKey || '',
                    configValue: record.configValue || '',
                    configRemark: record.configRemark || ''
                };
            } else {
                this.configFormData = {
                    id: null,
                    configKey: '',
                    configValue: '',
                    configRemark: ''
                };
            }
        },
        closeConfigForm() {
            this.configFormVisible = false;
            setTimeout(() => {
                this.configFormData = {
                    id: null,
                    configKey: '',
                    configValue: '',
                    configRemark: ''
                };
            }, 200);
        },
        handleConfigSave() {
            const { configKey, configValue, configRemark, id } = this.configFormData;
            if (!configKey || String(configKey).trim() === '') {
                this.$message.warning(this.$t(I18N_KEY.COLLECTION + 'configKeyMsg'));
                return;
            }
            if (!configValue || String(configValue).trim() === '') {
                this.$message.warning(this.$t(I18N_KEY.COLLECTION + 'configValueMsg'));
                return;
            }
            this.configSaveLoading = true;
            const params = {
                configKey: String(configKey).trim(),
                configValue: String(configValue).trim(),
                configRemark: configRemark ? String(configRemark).trim() : ''
            };
            if (this.configFormType === 'edit' && id) {
                params.id = id;
            }
            saveSurveillanceConfig(params)
                .then((res) => {
                    this.configSaveLoading = false;
                    if (res.code === 1000) {
                        this.$message.success(this.configFormType === 'add' ? this.$t(I18N_KEY.COLLECTION + 'addSuc') : this.$t(I18N_KEY.COLLECTION + 'editSuc'));
                        this.closeConfigForm();
                        this.loadConfigData();
                    } else {
                        this.$message.error(res.msg || 'save success');
                    }
                })
                .catch((e) => {
                    this.configSaveLoading = false;
                    this.$message.error(e.message || 'save exception');
                });
        },
        // ==================== 新增：用户催收详情方法 ====================
        openUserDetail(record) {
            this.userDetailUserId = record.userId || record.id;
            // 默认查询起止时间：当月第一天 ~ 今天
            const today = moment();
            this.userDetailQuery = {
                queryStartDate: today.clone().subtract(6, 'days').format('YYYY-MM-DD'),
                queryEndDate: today.format('YYYY-MM-DD')
            };
            this.userDetailForm.pageNum = 1;
            this.userDetailForm.pageSize = 10;
            this.userDetailDataSource = [];
            this.userDetailTotal = 0;
            this.initUserDetailColumns();
            this.userDetailVisible = true;
            this.loadUserDetail();
        },
        closeUserDetail() {
            this.userDetailVisible = false;
            this.userDetailUserId = null;
            this.userDetailDataSource = [];
            this.userDetailTotal = 0;
        },
        // 用户详情列：与主表字段完全一致，额外在第一列加"查询时间(queryDate)"
        initUserDetailColumns() {
            const h = this.$createElement;
            this.userDetailColumns = [
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'index'),
                    align: 'center',
                    width: 70,
                    customRender: (text, record, index) => {
                        const pageNum = this.userDetailForm.pageNum || 1;
                        const pageSize = this.userDetailForm.pageSize || 10;
                        return (pageNum - 1) * pageSize + index + 1;
                    }
                },
                // ===== 新增：查询时间列 =====
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'colQueryDate'),
                    align: 'center',
                    dataIndex: 'queryDate',
                    width: 120
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'groupName'),
                    align: 'center',
                    dataIndex: 'groupName'
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionLevel'),
                    align: 'center',
                    dataIndex: 'collectionLevel'
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionLoginNo'),
                    align: 'center',
                    dataIndex: 'collectionLoginNo'
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'locationStatus'),
                    align: 'center',
                    dataIndex: 'locationStatusName'
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'clockInStatus'),
                    align: 'center',
                    dataIndex: 'clockInStatusName'
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'callNum'),
                    align: 'center',
                    dataIndex: 'callNum',
                    scopedSlots: { customRender: 'userCallNumSlot' }
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionNum'),
                    align: 'center',
                    dataIndex: 'collectionNum'
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionRecordCount'),
                    align: 'center',
                    dataIndex: 'collectionRecordCount'
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'succedColNum'),
                    align: 'center',
                    dataIndex: 'succedNum'
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionRate'),
                    align: 'center',
                    dataIndex: 'collectionRate',
                    customRender: (text) => `${text ?? 0}%`
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'colBiasRate'),
                    align: 'center',
                    dataIndex: 'personSuccedColBiasRate',
                    customRender: (text) => `${text ?? 0}%`
                },
                // ===== 活跃度热力图列（复用主表逻辑） =====
                {
                    title: () => {
                        return h('span', [
                            this.$t(I18N_KEY.COLLECTION + 'collectionActivity'),
                            h('a-tooltip', {
                                props: { placement: 'top' },
                                scopedSlots: {
                                    title: () => h('div', this.$t(I18N_KEY.COLLECTION + 'activityMsg'))
                                }
                            }, [
                                h('a-icon', {
                                    props: { type: 'question-circle' },
                                    style: { marginLeft: '6px', color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }
                                })
                            ])
                        ]);
                    },
                    align: 'center',
                    dataIndex: 'collectionActivity',
                    scopedSlots: { customRender: 'userActivityHeatmap' },
                    width: 620
                }
            ];
        },
        loadUserDetail() {
            if (!this.userDetailUserId) return;

            if (!this.userDetailQuery.queryStartDate || !this.userDetailQuery.queryEndDate) {
                this.$message.warning(this.$t(I18N_KEY.COLLECTION + 'queryDateRequired'));
                this.userDetailLoading = false;
                return;
            }

            this.userDetailLoading = true;
            const params = filterObj({
                userId: this.userDetailUserId,
                queryStartDate: this.userDetailQuery.queryStartDate,
                queryEndDate: this.userDetailQuery.queryEndDate,
                pageNum: this.userDetailForm.pageNum,
                pageSize: this.userDetailForm.pageSize
            });
            queryUserCollectionDetail(params)
                .then((res) => {
                    if (res.code === 1000) {
                        const data = res.data || {};
                        this.userDetailTotal = data.total || 0;
                        const list = Array.isArray(data.list) ? data.list : [];
                        this.userDetailDataSource = list.map(item => ({
                            ...item,
                            lockLoading: false
                        }));
                    } else {
                        this.$message.error(res.msg || 'query fail');
                        this.userDetailDataSource = [];
                        this.userDetailTotal = 0;
                    }
                    this.userDetailLoading = false;
                })
                .catch((e) => {
                    this.userDetailLoading = false;
                    this.$message.error(e.message || 'query exception');
                });
        },
        handleUserDetailSearch() {
            if (!this.userDetailQuery.queryStartDate) {
                this.$message.warning(this.$t(I18N_KEY.COLLECTION + 'queryStartDateRequired'));
                return;
            }
            if (!this.userDetailQuery.queryEndDate) {
                this.$message.warning(this.$t(I18N_KEY.COLLECTION + 'queryEndDateRequired'));
                return;
            }
            // ===== 区间合法性校验（可选，建议加） =====
            if (moment(this.userDetailQuery.queryStartDate).isAfter(moment(this.userDetailQuery.queryEndDate))) {
                this.$message.warning(this.$t(I18N_KEY.COLLECTION + 'dateRangeInvalid'));
                return;
            }

            this.userDetailForm.pageNum = 1;
            this.loadUserDetail();
        },
        handleUserDetailTableChange(pageNum, pageSize) {
            this.userDetailForm.pageNum = pageNum;
            this.userDetailForm.pageSize = pageSize;
            this.loadUserDetail();
        },
    },
}
</script>
<style lang="less">
/* ============================================
   深色表格 hover 高亮 —— 适配深色主题
   ============================================ */
.dark-table .ant-table-tbody > tr > td {
    background: #141b2d;
    background-color: #141b2d;
    color: rgba(255, 255, 255, 0.85);
}

/* hover 时换成稍亮的深蓝灰，文字保持白色可见 */
.dark-table .ant-table-tbody > tr:hover > td,
.dark-table .ant-table-tbody > tr.ant-table-row-hover > td,
.dark-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background: #1f2940 !important;
    background-color: #1f2940 !important;
    color: rgba(255, 255, 255, 0.95) !important;
}

/* 选中行稍微再深一点区分 */
.dark-table .ant-table-tbody > tr.ant-table-row-selected > td {
    background: #1a2236 !important;
}

/* 表格内所有 a 链接，hover/focus 不要白底 */
.dark-table .ant-table-tbody a,
.dark-table .ant-table-tbody a:hover,
.dark-table .ant-table-tbody a:focus,
.dark-table .ant-table-tbody a:active,
.dark-table .ant-table-tbody a:visited {
    background: transparent !important;
    background-color: transparent !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    text-decoration: none !important;
}
</style>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
/deep/ .status-dropdown-fix {
    max-height: 300px !important;
    overflow-y: auto !important;
    overscroll-behavior: contain !important;
    z-index: 1050 !important;
}
/deep/ .status-dropdown-fix .ant-select-dropdown-menu {
    max-height: 300px !important;
    overflow-y: auto !important;
    overscroll-behavior: contain !important;
}
/* ========== 统计概览卡片样式 ========== */
.statistics-row {
    margin: 16px 0;
    .ant-col {
        margin-bottom: 12px;
    }
}
.stat-card {
    position: relative;
    background: #141b2d;
    border-radius: 10px;
    padding: 0 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    transition: transform 0.2s;
    height: 118px;
    &:hover {
        transform: translateY(-2px);
    }
    .stat-info {
        z-index: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        .stat-title {
            color: rgba(255, 255, 255, 0.5);
            font-size: 13px;
            margin-bottom: 10px;
            letter-spacing: 0.5px;
        }
        .stat-value {
            color: #fff;
            font-size: 26px;
            font-weight: 700;
            line-height: 1.2;
            .stat-unit {
                font-size: 13px;
                font-weight: 400;
                margin-left: 4px;
                opacity: 0.85;
            }
        }
        .stat-sub {
            color: rgba(255, 255, 255, 0.4);
            font-size: 12px;
            margin-top: 6px;
            min-height: 18px;
        }
    }
    .stat-icon {
        width: 44px;
        height: 44px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        flex-shrink: 0;
    }
}
.stat-card-cyan {
    .stat-value { color: #00d9ff; }
    .stat-icon { color: #00d9ff; background: rgba(0, 217, 255, 0.12); }
}
.stat-card-green {
    .stat-value { color: #00e676; }
    .stat-icon { color: #00e676; background: rgba(0, 230, 118, 0.12); }
}
.stat-card-yellow {
    .stat-value { color: #ffea00; }
    .stat-icon { color: #ffea00; background: rgba(255, 234, 0, 0.12); }
}
.stat-card-red {
    .stat-value { color: #ff4d4f; }
    .stat-icon { color: #ff4d4f; background: rgba(255, 77, 79, 0.12); }
}
/* ========== 排名概览卡片样式（含皇冠图标） ========== */
.rank-row {
    margin: 16px 0;
    .ant-col {
        margin-bottom: 12px;
    }
}
.rank-card {
    background: #141b2d;
    border-radius: 10px;
    padding: 16px 20px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    height: 100%;
    min-height: 240px;
}
.rank-header {
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .rank-title {
        color: #fff;
        font-size: 15px;
        font-weight: 600;
        letter-spacing: 0.5px;
        &::before {
            content: '';
            display: inline-block;
            width: 4px;
            height: 14px;
            border-radius: 2px;
            margin-right: 8px;
            vertical-align: middle;
        }
    }
    /* 新增：详情链接样式 */
    .rank-detail-link {
        color: #1890ff;
        font-size: 13px;
        cursor: pointer;
        
        &:hover {
            color: #40a9ff;
        }
    }
    &.rank-header-cyan .rank-title::before {
        background: #00d9ff;
    }
    &.rank-header-green .rank-title::before {
        background: #00e676;
    }
    &.rank-header-yellow .rank-title::before {
        background: #ffea00;
    }
    &.rank-header-red .rank-title::before {
        background: #ff4d4f;
    }
}
.rank-list {
    .rank-item {
        display: flex;
        align-items: center;
        padding: 8px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.04);
        &:last-child {
            border-bottom: none;
        }
    }
}
/* 排名序号 + 皇冠 组合区域 */
.rank-badge {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 10px;
    min-width: 48px;

    .rank-index {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.08);
        color: rgba(255, 255, 255, 0.6);
        font-size: 12px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        &.rank-top3 {
            background: rgba(255, 174, 0, 0.2);
            color: #ffae00;
        }
    }

    /* 皇冠图标 */
    .rank-crown {
        font-size: 14px;
        margin-left: 4px;
        flex-shrink: 0;

        &.rank-crown-gold {
            color: #FFD700;
        }

        &.rank-crown-silver {
            color: #C0C0C0;
        }

        &.rank-crown-bronze {
            color: #CD7F32;
        }
    }
}

.rank-name {
    flex: 1;
    color: rgba(255, 255, 255, 0.75);
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 8px;
}

.rank-value {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    flex-shrink: 0;
}

.rank-empty {
    text-align: center;
    color: rgba(255, 255, 255, 0.3);
    font-size: 13px;
    padding: 40px 0;
}

/* ========== 活跃度热力图：三段式 ========== */
.heatmap-row {
    display: flex;
    align-items: center;
    gap: 4px;              /* 三段之间的间距 */
    width: 100%;
    padding: 2px 0;
    box-sizing: border-box;
}

/* 每一段是一个带边框的容器 */
.heatmap-segment {
    display: flex;
    align-items: center;
    gap: 1px;
    height: 22px;
    padding: 1px 3px;
    border-radius: 4px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.02);
    overflow: hidden;
    flex: 0 0 auto;        /* 宽度由内部格子数量撑开 */
}

/* 上班前：蓝灰边框，低调 */
.heatmap-segment-before {
    border: 1px solid rgba(140, 160, 200, 0.55);
}

/* 工作时间：青色边框 + 微弱发光，最醒目 */
.heatmap-segment-work {
    border: 1px solid rgba(0, 217, 255, 0.9);
    box-shadow: 0 0 6px rgba(0, 217, 255, 0.35);
    background: rgba(0, 217, 255, 0.06);
}

/* 下班后：橙红边框 */
.heatmap-segment-after {
    border: 1px solid rgba(255, 140, 80, 0.7);
}

/* 小格子本体 */
.heatmap-cell {
    flex: 0 0 3px;
    width: 3px;
    height: 16px;
    border-radius: 1px;
    cursor: pointer;
    transition: transform 0.2s, opacity 0.2s;

    &:hover {
        transform: scaleY(1.3);
        opacity: 0.8;
    }
}

/* ========== 深色表格主题 ========== */
.dark-table {
    /deep/ .ant-table {
        background: transparent;
        color: rgba(255, 255, 255, 0.85);
    }

    /deep/ .ant-table-thead > tr > th {
        background: #1a2236;
        color: rgba(255, 255, 255, 0.85);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        font-weight: 600;
    }

    /deep/ .ant-table-tbody > tr > td {
        background: #141b2d;
        color: rgba(255, 255, 255, 0.85);
        border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    }

    /deep/ .ant-table-tbody > tr:hover > td {
        background: #141b2d;
    }

    /deep/ .ant-table-bordered .ant-table-thead > tr > th,
    /deep/ .ant-table-bordered .ant-table-tbody > tr > td {
        border-right: 1px solid rgba(255, 255, 255, 0.08);
    }

    /deep/ .ant-table-bordered .ant-table-thead > tr > th:last-child,
    /deep/ .ant-table-bordered .ant-table-tbody > tr > td:last-child {
        border-right: none;
    }

    /deep/ .ant-table-placeholder {
        background: #141b2d;
        color: rgba(255, 255, 255, 0.4);
        border-top: 1px solid rgba(255, 255, 255, 0.08);
    }

    /deep/ .ant-empty-description {
        color: rgba(255, 255, 255, 0.4);
    }

    /deep/ .ant-table-tbody > tr.ant-table-row-selected td {
        background: #1a2236;
    }
}

/* ========== 深色分页器 ========== */
.dark-pagination-wrapper {
    /deep/ .ant-pagination-item {
        background: #141b2d;
        border-color: rgba(255, 255, 255, 0.15);
        a {
            color: rgba(255, 255, 255, 0.65);
        }
    }

    /deep/ .ant-pagination-item-active {
        background: #1890ff;
        border-color: #1890ff;
        a {
            color: #fff;
        }
    }

    /deep/ .ant-pagination-prev .ant-pagination-item-link,
    /deep/ .ant-pagination-next .ant-pagination-item-link {
        background: #141b2d;
        border-color: rgba(255, 255, 255, 0.15);
        color: rgba(255, 255, 255, 0.65);
    }

    /deep/ .ant-pagination-disabled .ant-pagination-item-link {
        color: rgba(255, 255, 255, 0.25);
    }

    /deep/ .ant-pagination-options-quick-jumper {
        color: rgba(255, 255, 255, 0.65);
        input {
            background: #141b2d;
            border-color: rgba(255, 255, 255, 0.15);
            color: rgba(255, 255, 255, 0.85);
        }
    }

    /deep/ .ant-pagination-total-text {
        color: rgba(255, 255, 255, 0.5);
    }
}

/* 配置弹窗内边距优化 */
.config-modal-wrapper {
    /deep/ .ant-form-inline .ant-form-item {
        margin-bottom: 12px;
    }
}

/* ========== 新增：用户催收详情弹窗样式 ========== */
.user-detail-wrapper {
    /deep/ .ant-form-inline .ant-form-item {
        margin-bottom: 12px;
    }
}

.detail-link-btn {
    display: inline-block;
    color: #1890ff;
    background: transparent !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    padding: 0 4px;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.2s;

    &:hover,
    &:focus,
    &:active,
    &:visited {
        color: #40a9ff;
        background: transparent !important;
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        text-decoration: none;
    }
}
</style>